// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"6d60433a","726":"3bc2284a"}[chunkId] + ".chunk.js";
};